import { cva, type VariantProps } from 'class-variance-authority';

export const loadingDotVariants = cva(
  'rounded-full motion-reduce:animate-none',
  {
    variants: {
      size: {
        sm: 'w-2 h-2',
        md: 'w-8 h-8',
        lg: 'w-12 h-12',
      },
      color: {
        white: 'bg-white',
        primary: 'bg-primary-700',
        secondary: 'bg-secondary-700',
        neutral: 'bg-neutral-500',
      },
    },
    defaultVariants: {
      size: 'md',
      color: 'white',
    },
  },
);

export type LoadingDotVariantProps = VariantProps<typeof loadingDotVariants>;
